import config from '@config';

export default (data: string | string[], lang = config.language) => {
    let translations;

    if (!data) {
        return '';
    }

    if (typeof data === 'string') {
        translations = data.split('|');
    } else {
        translations = data;
    }

    const [
        englishTranslation = '',
        romanianTranslation = '',
        // eslint-disable-next-line no-unused-vars
        _placeholder1,
        // eslint-disable-next-line no-unused-vars
        _placeholder2,
        polishTranslations = '',
        croatianTranslations = ''
    ] = translations;

    switch (lang) {
        case 'en':
            return englishTranslation || romanianTranslation;
        case 'ro':
            return romanianTranslation || englishTranslation;
        case 'pl':
            return polishTranslations || englishTranslation;
        case 'hr':
            return croatianTranslations || englishTranslation;
        default:
            return englishTranslation;
    }
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/core/utils/mappers/helpers.ts